import { CalibrationVideo, Video } from "../types/index";

/*
        // Get metadata from the first record's first video
        if (records.length === 0 || records[0].videos.length === 0) {
            return null;
        }

        const masterVideo = records[0].videos.find(v => v.is_master) || records[0].videos[0];
*/
export const findBestMatchingCalibration = (video: Video, calibrationVideos: CalibrationVideo[]): CalibrationVideo | null => {

    // Filter to completed calibration videos only
    const completedVideos = calibrationVideos.filter(v => v.status === 'completed');

    if (completedVideos.length === 0) {
        return null;
    }

    // Extract metadata from uploaded video
    const uploadedCameraModel = video.camera_model;
    const uploadedCameraMode = video.camera_mode;
    const uploadedImageWidth = video.image_width;
    const uploadedImageHeight = video.image_height;

    console.log('[CALIBRATION_MATCHING] Uploaded video metadata:', {
        camera: video.camera,
        camera_model: uploadedCameraModel,
        camera_mode: uploadedCameraMode,
        image_width: uploadedImageWidth,
        image_height: uploadedImageHeight
    });

    // Score each calibration video based on priority criteria
    const scoredVideos = completedVideos.map(video => {
        let score = 0;
        const matchDetails = [];

        // Priority 1: Same camera model (8,000 points) - CRITICAL
        if (uploadedCameraModel && video.camera_model &&
            video.camera_model.toLowerCase() === uploadedCameraModel.toLowerCase()) {
            score += 8000;
            matchDetails.push('model_match');
        }

        // Priority 2: Same camera mode (7,000 points) - VERY CRITICAL (Linear vs Wide)
        if (uploadedCameraMode && video.camera_mode &&
            video.camera_mode.toLowerCase() === uploadedCameraMode.toLowerCase()) {
            score += 7000;
            matchDetails.push('mode_match');
        }

        // Priority 3: Same image resolution (6,000 points)
        if (uploadedImageWidth && uploadedImageHeight &&
            video.image_width === uploadedImageWidth &&
            video.image_height === uploadedImageHeight) {
            score += 6000;
            matchDetails.push('resolution_match');
        }

        // Priority 4: Same camera ID (5,000 points)
        if (video.camera && video.camera === video.camera) {
            score += 5000;
            matchDetails.push('camera_id_match');
        }


        // Priority 6: Most recent videos (by ID, +0.01 to +100 points)
        score += video.id / 100; // ID 10000 = +100, ID 1000 = +10, ID 100 = +1

        console.log(`[CALIBRATION_MATCHING] Video ${video.id} (${video.camera}): score=${score}, matches=[${matchDetails.join(', ')}]`, {
            calibration: {
                camera: video.camera,
                model: video.camera_model,
                mode: video.camera_mode,
                resolution: `${video.image_width}x${video.image_height}`
            }
        });

        return { video, score };
    });

    // Sort by score (highest first)
    scoredVideos.sort((a, b) => b.score - a.score);

    const best = scoredVideos[0];

    // IMPORTANT: Only auto-select if we have a meaningful match
    // Minimum requirement: Either have camera model+mode match OR camera ID+active OR just camera ID
    // Require at least one of:
    // - Same camera model AND mode (15,000+) = Perfect match
    // - Same camera model OR mode + same image size (>= 6,000)
    // - Same camera ID (5,000+)
    // - Active calibration (3,000+)
    if (best.score >= 3000) {
        return best.video;
    }

    // No good match found (score < 3000), return null to use defaults
    // This means no camera match, no active calibration, not even same model/mode/resolution
    return null;
};
